import {useCallback, useState, useEffect} from 'react'
import {Filter} from '@github-ui/filter'
import type {FilterQuery} from '@github-ui/filter-core'

import styles from './Search.module.css'

type Props = {
  searchQuery: string
  onSearchChange: (query: string) => void
}

export function Search({searchQuery, onSearchChange}: Props) {
  const [localValue, setLocalValue] = useState(searchQuery)

  // Update local value when searchQuery prop changes (e.g., from URL)
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setLocalValue(searchQuery)
  }, [searchQuery])

  const handleQueryChange = useCallback((value: string) => {
    // Update local state to show what user is typing, but don't trigger search
    setLocalValue(value)
  }, [])

  const handleSubmit = useCallback(
    (filterQuery: FilterQuery) => {
      onSearchChange(filterQuery.raw)
    },
    [onSearchChange],
  )

  return (
    <Filter
      id="mcp-registry-search-filter"
      data-testid="mcp-registry-search-filter"
      providers={[]}
      /* eslint-disable-next-line @github-ui/dotcom-primer/no-title-case -- baselined during linter rollout */
      label="Search MCP Registry"
      variant="input"
      filterValue={localValue}
      className={styles.input}
      /* eslint-disable-next-line @github-ui/dotcom-primer/no-title-case -- baselined during linter rollout */
      placeholder={'Search MCPs'}
      settings={{
        disableAdvancedTextFilter: true,
        groupAndKeywordSupport: false,
      }}
      onChange={handleQueryChange}
      onSubmit={handleSubmit}
    />
  )
}
